import React, { useState } from "react";
import { Plus } from "lucide-react";
import SectionShell from "./SectionShell";

const FAQ = [
  {
    q: "How is Prospera compensated?",
    a: "Insurance products pay a commission from the carrier (disclosed in writing before you sign anything). Investment accounts may be flat-fee, embedded MER, or fee-based depending on the platform. In every case, you'll see a written breakdown of every dollar we're paid, and we'll explain the mechanics until you're comfortable.",
  },
  {
    q: "Is Prospera a fiduciary?",
    a: "Yes. Under Ontario's regulatory regime for both insurance (FSRA) and securities (CIRO/OSC), we operate under a duty of care. In addition, our internal client agreement commits us, in writing, to the fiduciary standard of putting your interests before ours.",
  },
  {
    q: "What's the minimum to work with you?",
    a: "There is no hard minimum. We serve young families building their first policy through business owners with eight-figure balance sheets. What we ask for is engagement: clients willing to share the full picture and act on the plan.",
  },
  {
    q: "Who regulates you?",
    a: "Insurance activity is regulated by the Financial Services Regulatory Authority of Ontario (FSRA). Investment activity is regulated by the Canadian Investment Regulatory Organization (CIRO) and the Ontario Securities Commission (OSC). Investment accounts are protected up to CIPF limits. Prospera Financial Inc. is an Ontario corporation.",
  },
  {
    q: "Do you work with clients outside Ontario?",
    a: "Yes, we are licensed to serve clients across most Canadian provinces. Cross-border (US) work is handled through partnered counsel on a case-by-case basis.",
  },
  {
    q: "What happens after the first meeting?",
    a: "You'll receive a written summary of what we discussed, a proposed engagement letter (if we're a fit), and, most importantly, no follow-up pressure. Great advice takes time; the second meeting is scheduled only when you're ready.",
  },
];

function FaqItem({ item, i, isOpen, onToggle }) {
  return (
    <div className="border-b border-[#E6E2D8]">
      <button
        onClick={onToggle}
        data-testid={`faq-${i}`}
        aria-expanded={isOpen}
        className="w-full flex items-center justify-between gap-6 py-6 text-left group"
      >
        <span className="font-display text-[#0B1F3F] text-xl md:text-[22px] leading-snug group-hover:text-[#8A6A2E] transition-colors">
          {item.q}
        </span>
        <span
          className={`shrink-0 w-9 h-9 rounded-full border flex items-center justify-center transition-[transform,background-color,border-color] duration-300 ${
            isOpen ? "rotate-45 bg-[#0B1F3F] border-[#0B1F3F] text-white" : "border-[#CFC9BB] text-[#0B1F3F]"
          }`}
        >
          <Plus size={15} />
        </span>
      </button>
      <div
        className="grid transition-[grid-template-rows] duration-500 ease-in-out"
        style={{ gridTemplateRows: isOpen ? "1fr" : "0fr" }}
      >
        <div className="overflow-hidden">
          <p className="text-[#5A6476] text-[15px] leading-relaxed pb-6 pr-12">{item.a}</p>
        </div>
      </div>
    </div>
  );
}

export default function FAQSection() {
  const [open, setOpen] = useState(0);
  return (
    <SectionShell id="faq" eyebrow="Frequently asked" variant="elevated" data-testid="faq">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <h2 className="lg:col-span-4 font-display text-[#0B1F3F] text-4xl sm:text-5xl tracking-tight leading-[1.08]">
          The questions clients ask before signing.
        </h2>
        <div className="lg:col-span-8 border-t border-[#E6E2D8]">
          {FAQ.map((item, i) => (
            <FaqItem
              key={item.q}
              item={item}
              i={i}
              isOpen={open === i}
              onToggle={() => setOpen(open === i ? -1 : i)}
            />
          ))}
        </div>
      </div>
    </SectionShell>
  );
}
